import { v4 as uuidv4 } from 'uuid';
import {
  checkOnlyDateFormatAndUpdateFormat,
  currentDateFormat,
  DATE_FORMAT_MAPPING,
  DATE_FORMATS
} from '../../utils/transformChartsAndTableData';
import { get } from 'lodash';

export function transformApiResponse(apiData) {
  try {
    const { columns, rows, metric_data, metric_count } = apiData?.data;

    return rows.map((rowName, rowIndex) => {
      const rowObj = {
        id: uuidv4(),
        primary: rowName,
        metric_type: get(apiData, ['widget_config', 'metric_type'], ''),
        topic_filter: get(apiData, ['widget_config', 'topic_filter'], ''),
        topic_depth: get(apiData, ['widget_config', 'topic_depth'], '')
      };

      const emptyRowObjPlaceholder = {
        id: uuidv4(),
        primary: null
      };

      columns.forEach((colName, colIndex) => {
        const keyBase = colName
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '');

        rowObj[keyBase] = metric_data[rowIndex][colIndex];
        rowObj[keyBase + '_count'] = metric_count[rowIndex][colIndex];

        emptyRowObjPlaceholder[keyBase] = null;
        emptyRowObjPlaceholder[keyBase + '_count'] = null;
      });

      if (get(apiData, ['widget_config', 'topic_depth'], '') !== 'l3' && rowName !== 'Sample Size') {
        rowObj.subData = [emptyRowObjPlaceholder];
      }

      return rowObj;
    });
  } catch (err) { }
}

export function transformApiResponseToColumns(apiData) {
  const { columns } = apiData?.data || [];
  const primaryLabel = _.startCase(_.toLower(get(apiData, ['widget_config', 'segment_type'], 'Topic')));

  const mapped = (columns || []).map(colName => {
    const field = colName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');

    return {
      field,
      label: _.startCase(
        _.toLower(
          checkOnlyDateFormatAndUpdateFormat(colName, DATE_FORMAT_MAPPING[currentDateFormat(colName, DATE_FORMATS)])
        )
      )
    };
  });
  mapped.unshift({ field: 'primary', label: primaryLabel, type: 'link', width: 200 });
  return mapped;
}

export function formatTwoDecimalsIfNeeded(value) {
  if (value === null || value === undefined) return value;
  const str = String(value);
  if (!str.includes('.')) return value;
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toFixed(2);
}

